<template>
    <v-footer v-if="$isDesktop()" id="pages-core-footer" absolute color="transparent" dark>
        <v-container>
            <v-row align="center" no-gutters>
                <div>
                    <v-col
                    v-for="(link, i) in links"
                    :key="i"
                    class="text-center mb-sm-0 mb-5"
                    cols="auto">
                        <a :href="link.href" class="mr-0" rel="noopener" target="_blank" v-text="link.text" />
                    </v-col>
                </div>
                <v-spacer class="hidden-sm-and-down" />
                <v-col cols="12" md="auto">
                    <div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
                        &copy; 2020-2023 <a :href="CONF_CLIENT_URL" target="_blank">{{ CONF_CLIENT_URL_WRITTEN }}</a> - All rights reserved, made with
                        <v-icon size="18">
                            mdi-heart
                        </v-icon>
                        for a better journey. ({{ CONF_REVISIONS_NUMBER }} - {{ CONF_SCHEDULER_VERSION }}, {{ CONF_VERSION_NUMBER }})
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
	import {
        CONF_VERSION_NUMBER,
        CONF_REVISIONS_NUMBER,
        CONF_SCHEDULER_VERSION,
        CONF_CLIENT,
        CONF_CLIENT_URL,
        CONF_CLIENT_URL_WRITTEN,
        CONF_CLIENT_URL_APPS,
        CONF_CLIENT_URL_APPS_WRITTEN
    } from '../../../../config';



    export default {
        name: 'PagesCoreFooter',

        /* >>> *************************************************************** / /* Data */
        data: () => ({

            links: [
                {
                    href: CONF_CLIENT_URL_APPS,
                    text: CONF_CLIENT_URL_APPS_WRITTEN
                }
            ],
            // >>> -------------------------- CONFIG
            CONF_VERSION_NUMBER: CONF_VERSION_NUMBER,
            CONF_REVISIONS_NUMBER: CONF_REVISIONS_NUMBER,
            CONF_SCHEDULER_VERSION: CONF_SCHEDULER_VERSION,
            CONF_CLIENT: CONF_CLIENT,
            CONF_CLIENT_URL: CONF_CLIENT_URL,
            CONF_CLIENT_URL_WRITTEN: CONF_CLIENT_URL_WRITTEN,
            CONF_CLIENT_URL_APPS: CONF_CLIENT_URL_APPS,
            CONF_CLIENT_URL_APPS_WRITTEN: CONF_CLIENT_URL_APPS_WRITTEN

        }) // eof data()
        /* <<< ****************************************************************/

    };
</script>

<style lang="sass">
  #pages-core-footer
    a
      color: #FFFFFF
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
